import { datadogLogs } from '@datadog/browser-logs'

declare global {
  interface Window {
    Cookiebot?: {
      consent?: {
        statistics: boolean
      }
    }
  }

  interface WindowEventMap {
    CookiebotOnAccept: Event
    CookiebotOnConsentReady: Event
  }
}

let initialized = false

const init = () => {
  const dataDogClientToken = process.env.REACT_APP_DATA_DOG_CLIENT_TOKEN
  const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT
  const isLocalEnvironment = (environment ?? 'local') === 'local'
  const isTestEnvironment = process.env.NODE_ENV === 'test'

  if (
    initialized ||
    !dataDogClientToken ||
    isLocalEnvironment ||
    isTestEnvironment
  ) {
    return
  }

  initialized = true

  // RUM disabled for legal/privacy review (issue #358); only browser-log error forwarding kept.
  datadogLogs.init({
    clientToken: dataDogClientToken,
    service: 'web',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
  })
}

// datadogLogs writes the _dd_s cookie, and Cookiebot cannot auto-block code
// bundled into the app, so it must stay dormant until the visitor grants
// statistics consent. CookiebotOnConsentReady covers returning visitors whose
// choice is already stored; CookiebotOnAccept covers consent given on this page.
const initIfStatisticsConsented = () => {
  if (window.Cookiebot?.consent?.statistics) {
    init()
  }
}

initIfStatisticsConsented()
window.addEventListener('CookiebotOnConsentReady', initIfStatisticsConsented)
window.addEventListener('CookiebotOnAccept', initIfStatisticsConsented)
